<template>
  <div>
    <div class="title">
      <!-- <img :src="img" alt="" /> -->
      <h3>{{ question }}</h3>
    </div>
    <div class="answer">
      {{ answer }}
    </div>
  </div>
</template>

<script>
export default {
  name: "question",
  data() {
    return {};
  },
  props: {
    question: String,
    answer: String,
    img: String
  }
};
</script>

<style lang="less" scoped>
.title {
  height: 20px;
  line-height: 20px;
  img {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-top: 2px;
    margin-right: 15px;
  }
  h3 {
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
}
.answer {
  margin-top: 8px;
  height: 18px;
  line-height: 18px;
  // text-indent: 35px;
  color: #333;
  font-size: 14px;
}
</style>
